export const spacing = {
	xxs: 2,
	xs: 4,
	sm: 8,
	md: 12,
	lg: 16,
	xl: 20,
	xxl: 24,
} as const

export type SpacingSize = keyof typeof spacing

export type AlignY = 'top' | 'center' | 'bottom' | 'stretch'
export type AlignX = 'left' | 'center' | 'right' | 'spaceBetween' | 'spaceAround'
export type Wrap = 'nowrap' | 'wrap'

export const alignYToFlexAlign = {
	top: 'flex-start',
	center: 'center',
	bottom: 'flex-end',
	stretch: 'stretch',
} as const

export const alignXToFlexAlign = {
	left: 'flex-start',
	center: 'center',
	right: 'flex-end',
	spaceBetween: 'space-between',
	spaceAround: 'space-around',
} as const
